import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PosStation } from '../../_models/fundraising/PosStation';
import { StationService } from '../../_services/fundraising/station.service';

@Component({
  selector: 'app-operator-station-link-modal',
  templateUrl: './operator-station-link-modal.component.html',
  styleUrls: ['./operator-station-link-modal.component.css']
})
export class OperatorStationLinkModalComponent implements OnInit {

  public operator;

  public availableStations: PosStation[];

  @Output() hasError = new EventEmitter();

  constructor(
    private stationService: StationService,
    private bsModalRef: BsModalRef
  ) { }

  ngOnInit() {

    this.stationService.getAll()
      .subscribe(
        data => {
          this.availableStations = data;        
        },
        error => {
          this.hasError.emit(true);
          this.bsModalRef.hide();
        }
      );
  }

  assignStation(stationId: number) {
    this.operator.stationId = stationId;
  }

  saveAndClose() {

    this.stationService.stationOperatorLink(this.operator.stationId, this.operator.operatorId)
      .subscribe(
        () => { 
          this.close();
        },
        error => {
          this.hasError.emit(true);
          this.bsModalRef.hide();
        }
      );
  }

  close() {
    this.hasError.emit(false);
    this.bsModalRef.hide();
  }

}

